export default {
    'hostApp': 'https://app.applicolis.com',
    'hostApi': 'https://app.applicolis.com/api/',
    'mapboxToken': 'pk.eyJ1IjoiYXBwbGljb2xpcyIsImEiOiJja3psZTdhbTMyZHJhMnZvMGZ0cDVsMDJxIn0.ygDaHmFNUsD2YOpOYtjtEA',
    'googleApiKey': 'AIzaSyDOUFqse9R-UKd9yJ5dm1uRQhy89EHDyyA'
}
